import gql from 'graphql-tag'

export const Q_GET_AUDIT_LOGS = gql`
  query ($where: ListWhere, $limit: Int, $offset: Int, $order: String) {
    auditLogs(where: $where, limit: $limit, offset: $offset, order: $order) {
      id
      action
      modelName
      recordId
      actorEmail
      changedFields
      previousValues
      currentValues
      meta
      createdAt
      updatedAt
    }
  }
`
